<ng-container *ngIf="fileInfo">
  <app-simple-document-viewer
    *ngIf="fileInfo.viewerType === 'simple'"
    [storageFile]="fileInfo.storageFile"
    [operationType]="operationType"
    [productType]="productType"
    [personType]="personType"
    (close)="closeDocumentViewer()"></app-simple-document-viewer>

  <ng-container *ngIf="fileInfo.viewerType === 'custom'">
    <ng-template [cdkPortalOutlet]="fileInfo.customPortal!"></ng-template>
  </ng-container>
</ng-container>
